import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/notification.service';
import { InvoiceSalary } from 'src/app/shared/InvoiceSalary.model';
import { InvoiceSalaryService } from 'src/app/shared/InvoiceSalary.service';
import { InvoiceSalaryDetail } from 'src/app/shared/InvoiceSalaryDetail.model';
import { InvoiceSalaryDetailService } from 'src/app/shared/InvoiceSalaryDetail.service';
import { Supplier } from 'src/app/shared/Supplier.model';
import { SupplierService } from 'src/app/shared/Supplier.service';
import { Membership } from 'src/app/shared/Membership.model';
import { MembershipService } from 'src/app/shared/Membership.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DownloadService } from 'src/app/shared/Download.service';

@Component({
  selector: 'app-invoice-salary-detail',
  templateUrl: './invoice-salary-detail.component.html',
  styleUrls: ['./invoice-salary-detail.component.css']
})
export class InvoiceSalaryDetailComponent implements OnInit {

  ID: number = environment.InitializationNumber;
  isShowLoading: boolean = false;

  dataSource: MatTableDataSource<any>;
  displayColumns: string[] = ['SupplierID', 'Quantity', 'Price', 'Total', 'Save'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public InvoiceSalaryService: InvoiceSalaryService,
    public InvoiceSalaryDetailService: InvoiceSalaryDetailService,
    public SupplierService: SupplierService,
    public MembershipService: MembershipService,
    public NotificationService: NotificationService,
    public DownloadService: DownloadService,
    public dialogRef: MatDialogRef<InvoiceSalaryDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ID = data["ID"] as number;
  }
  ngOnInit(): void {        
    this.GetMembershipToListAsync();    
    this.GetByParentIDAndEmptyToListAsync();
  }  
  GetMembershipToListAsync() {
    this.MembershipService.GetAllToListAsync().subscribe(
      res => {
        this.MembershipService.list = (res as Membership[]).sort((a, b) => (a.Display > b.Display ? 1 : -1));        
      },
      err => {
      }
    );
  }
  onClose() {
    this.dialogRef.close();
  }

  onSubmit(form: NgForm) {
    this.InvoiceSalaryService.SaveAsync(form.value).subscribe(
      res => {
        this.InvoiceSalaryService.formData = res as InvoiceSalary;
        this.GetByIDAsync();
        this.NotificationService.success(environment.SaveSuccess);
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
      }
    );
  }
  onChangeDateCreated(value) {
    this.InvoiceSalaryService.formData.DateCreated = new Date(value);
  }
  GetByIDAsync() {
    this.InvoiceSalaryService.GetByIDAsync(this.InvoiceSalaryService.formData.ID).subscribe(
      res => {
        this.InvoiceSalaryService.formData = res as InvoiceSalary;     
        this.GetByParentIDAndEmptyToListAsync();  
      },
      err => {
      }
    );
  }
  GetByParentIDAndEmptyToListAsync() {
    this.isShowLoading = true;
    this.InvoiceSalaryDetailService.GetByParentIDAndEmptyToListAsync(this.InvoiceSalaryService.formData.ID).subscribe(
      res => {
        this.InvoiceSalaryDetailService.list = res as InvoiceSalaryDetail[];
        this.dataSource = new MatTableDataSource(this.InvoiceSalaryDetailService.list.sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1)));
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isShowLoading = false;        
      },
      err => {
        this.isShowLoading = false;
      }
    );
  }
  onSave(element: InvoiceSalaryDetail) {
    element.ParentID = this.InvoiceSalaryService.formData.ID;
    this.InvoiceSalaryDetailService.SaveAsync(element).subscribe(
      res => {
        this.GetByIDAsync();
        this.NotificationService.warn(environment.SaveSuccess);
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
      }
    );
  }
  onDelete(element: InvoiceSalaryDetail) {
    if (confirm(environment.DeleteConfirm)) {
      this.InvoiceSalaryDetailService.RemoveAsync(element.ID).subscribe(
        res => {
          this.GetByIDAsync();
          this.NotificationService.warn(environment.DeleteSuccess);
        },
        err => {
          this.NotificationService.warn(environment.DeleteNotSuccess);
        }
      );
    }
  } 
}